import { render, staticRenderFns } from "./DocumentsSummaryItem.vue?vue&type=template&id=235cf21c"
import script from "./DocumentsSummaryItem.vue?vue&type=script&lang=js"
export * from "./DocumentsSummaryItem.vue?vue&type=script&lang=js"
import style0 from "./DocumentsSummaryItem.vue?vue&type=style&index=0&id=235cf21c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports